import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./SchemaEnums.vue.script.js";
/* empty css                          */
//#region src/schema/SchemaEnums.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-1b21ab2e"]]);
//#endregion
export { n as default };

//# sourceMappingURL=SchemaEnums.vue.js.map